interface MenuSubmenu {
  translationKey: string;
  id: string;
}

interface MenuItem {
  translationKey: string;
  id: string;
  submenu?: MenuSubmenu[];
}

export const MENU_ITEMS: MenuItem[] = [
  // { translationKey: 'pricing', id: 'pricing' },
  // { translationKey: 'faq', id: 'faq' },
  // { 
  //   translationKey: 'menu_places',
  //   id: 'places', 
  //   submenu: [
  //     { translationKey: 'submenu_entertainment', id: 'places/local-places' },
  //     { translationKey: 'submenu_restaurants', id: 'places/restaurants' },
  //     { translationKey: 'submenu_attractions', id: 'places/attractions' },
  //   ] 
  // },
  // { translationKey: 'menu_services', id: 'services' },
  { translationKey: 'submenu_attractions', id: 'places/attractions' },
  { translationKey: 'submenu_restaurants', id: 'places/restaurants' },
  { translationKey: 'submenu_entertainment', id: 'places/local-places' },
  { translationKey: 'menu_blogs', id: 'blogs' },
]

export const FEATURE_USER_ITEMS: MenuItem[] = [
  { translationKey: 'recent_results', id: 'recent-results' },
  { translationKey: 'favorite_items', id: 'favorite-items' }
]

export const ACCOUNT_ITEMS: MenuItem[] = [
  { translationKey: 'account_profile', id: 'profile' },
  { translationKey: 'account_membership', id: 'membership' },
  { translationKey: 'account_invitation', id: 'invitation' },
]